import { render, staticRenderFns } from "./platformBusinessRole.vue?vue&type=template&id=81c86878&scoped=true"
import script from "./platformBusinessRole.vue?vue&type=script&lang=js"
export * from "./platformBusinessRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c86878",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\pj\\Platform\\xrcNet\\xrcNet_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81c86878')) {
      api.createRecord('81c86878', component.options)
    } else {
      api.reload('81c86878', component.options)
    }
    module.hot.accept("./platformBusinessRole.vue?vue&type=template&id=81c86878&scoped=true", function () {
      api.rerender('81c86878', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/area/areamenu/platformBusinessRole.vue"
export default component.exports